common.View.create('shop::website.modules.shopProducts.index.filters.Categories', {

    onDOMLoad()
    {

    },

    updateHtml(ajaxResponse)
    {
        // Replace HTML.
        this.element.replaceWith(ajaxResponse.find('.shop\\:\\:website-modules-shopProducts-index-filters-Categories'));

        //
        common.View.reinit();
    },

});
